import type { ReactNode } from "react";

interface FormFieldProps {
  label: string;
  children: ReactNode;
  hint?: string;
  error?: string;
  fullWidth?: boolean;
  className?: string;
}

export function FormField({
  label,
  children,
  hint,
  error,
  fullWidth = false,
  className = "",
}: FormFieldProps) {
  return (
    <label
      className={[
        "form-field",
        fullWidth ? "form-field-full" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <span>{label}</span>
      {children}
      {hint ? <small className="text-xs text-[#919a9f]">{hint}</small> : null}
      {error ? <span className="text-xs text-red-600">{error}</span> : null}
    </label>
  );
}

interface FormGridProps {
  children: ReactNode;
  className?: string;
}

export function FormGrid({ children, className = "" }: FormGridProps) {
  return <div className={["form-grid", className].join(" ")}>{children}</div>;
}
